export default __webpack_public_path__ + "static/media/aeraUp.bcfa0e51.png";